module.exports = __webpack_public_path__ + "assets/icon-toggle-gray.8c9491df.svg";